export const workOrderReducer = (state, action) => {
  switch (action.type) {
    case "PLACED_SHIPPMENTS_LOADED":
      return {
        ...state,
        placedWorkOrders: action.payload,
        placedShipments: action.payload,
        currentWorkOrder: {},
        currentShipment: {},
        currentInventory: {},
      };
    case "CLEAR_NOTE":
      const newNotes = { ...state.notes };
      delete newNotes[action.payload.id];
      return {
        ...state,
        notes: newNotes,
      };
    case "UPDATE_CURRENT_SHIPMENT": {
      const payload = action.payload;
      const trackCar =
        payload.trackCar !== undefined
          ? payload.trackCar
          : state.currentShipment?.trackCar;
      return {
        ...state,
        currentWorkOrder: { ...payload, trackCar },
        currentShipment: { ...payload, trackCar },
      };
    }
    case "UPDATE_SHIPMENT_LOCATION": {
      const { shipmentId, trackId, locationFullName } = action.payload;
      if (state.currentShipment?.id !== shipmentId) return state;
      if (shipmentId == null || trackId == null) return state;
      const currentTrackCar = state.currentShipment?.trackCar || {};
      const nextTrackCar = {
        ...currentTrackCar,
        trackId,
        locationFullName: locationFullName ?? null,
      };

      return {
        ...state,
        currentWorkOrder: {
          ...state.currentWorkOrder,
          trackCar: nextTrackCar,
        },
        currentShipment: {
          ...state.currentShipment,
          trackCar: nextTrackCar,
        },
      };
    }
    case "UPDATE_CURRENT_INVENTORY":
      const items = state.currentShipment.inventories.items.map(
        (inventoryItem) =>
          inventoryItem.id === action.payload.id
            ? action.payload
            : inventoryItem,
      );
      return {
        ...state,
        currentInventory: { ...action.payload },
        currentWorkOrder: {
          ...state.currentWorkOrder,
          inventories: { items },
        },
        currentShipment: {
          ...state.currentShipment,
          inventories: { items },
        },
      };
    case "SET_CURRENT_SHIPPMENT":
      return {
        ...state,
        currentWorkOrder: { ...action.payload },
        currentShipment: { ...action.payload },
      };
    case "SET_SELECTED_OUTBOUND":
      return {
        ...state,
        selectedOutbound: action.payload ? { ...action.payload } : null,
      };
    case "SET_SHIPPMENT_NOTE":
      const newShipmentNotes = { ...state.notes };
      newShipmentNotes[action.payload.id] = action.payload.value;
      return {
        ...state,
        notes: newShipmentNotes,
      };
    case "SET_CURRENT_INVENTORY":
      return {
        ...state,
        currentInventory: { ...action.payload },
      };
    case "SET_MODE":
      return {
        ...state,
        mode: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_AISLES":
      return {
        ...state,
        aisles: action.payload,
      };
    case "SET_SELECTED_AISLE":
      return {
        ...state,
        selectedAisle: action.payload.aisle,
        bayList: action.payload.bayList,
        showCapacityDisplay: action.payload.showCapacityDisplay,
        selectedLocation: action.payload.selectedLocation,
        selectedInventoryItem: action.payload.selectedInventoryItem,
      };
    case "UPDATE_INVENTORY_ITEMS": {
      return {
        ...state,
        currentInventory: { ...action.payload },
      };
    }
    case "SELECT_INVENTORY_ITEM": {
      return {
        ...state,
        currentInventory: action.payload.currentInventory,
        selectedInventoryItem: action.payload.selectedInventoryItem,
        origInventoryItem: action.payload.origInventoryItem,
        selectedLocation: action.payload.selectedInventoryItem?.location,
        selectedAisle: action.payload.selectedInventoryItem?.location?.aisle,
        disableSelection: action.payload.disableSelection,
        bayList: [],
        displayState: "MAP",
      };
    }
    case "SET_SELECTED_INVENTORY_ITEM":
      return {
        ...state,
        selectedInventoryItem: action.payload,
        selectedLocation: action.payload?.location,
        selectedAisle: action.payload?.location?.aisle,
      };
    case "SET_SELECTED_LOCATION":
      return {
        ...state,
        selectedLocation: action.payload,
      };
    case "SET_IS_CONTAINER_NUMBER_VALIDATED":
      return {
        ...state,
        isContainerNumberValidated: action.payload,
      };
    case "SET_DISPLAY_STATE":
      return {
        ...state,
        displayState: action.payload.displayState,
        selectedAisle: null,
        selectedLocation: null,
        bayList: [],
        origInventoryItem: null,
      };
    case "DISABLE_SELECTION":
      return {
        ...state,
        disableSelection: action.payload,
      };
    case "INIT_ADD_INVENTORY_ITEM":
      return {
        ...state,
        ...action.payload,
        displayState: "MAP",
      };
    case "SET_AISLE_SEARCH_INVENTORIES":
      return {
        ...state,
        searchInventoryItemsMap: action.payload,
      };
    case "SET_SHOW_QUANTITY":
      return {
        ...state,
        showInventoryQuantity: action.payload,
      };
    case "CLEAR_INVENTORY":
      return {
        ...state,
        currentInventory: {},
        selectedInventoryItem: [],
        selectedLocation: null,
        bayList: [],
        searchInventoryItemsMap: {},
      };
    case "CLEAR_SHIPMENTS": {
      return {
        ...state,
        placedWorkOrders: [],
        placedShipments: [],
        currentWorkOrder: {},
        currentShipment: {},
        currentInventory: {},
      };
    }
    default:
      break;
  }
  return state;
};

export const inboundReducer = workOrderReducer;
